<template>
  <el-tooltip
    v-if="statuses[status]"
    effect="dark"
    placement="bottom-end"
    :content="statuses[status].desc"
  >
    <span>Статус агента: <i class="agent-status" :class="statuses[status].icon" style="position: relative; top: 1.1px;"/></span>
  </el-tooltip>
</template>

<script>
export default {
  name: "CameraAgentStatus",
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      statuses: {
        OK: {
          icon: "el-icon-success",
          desc: "Агент работает",
        },
        PROBLEM: {
          icon: "el-icon-warning",
          desc: "Проблема с агентом",
        },
        EMPTY_CONNECT: {
          icon: "el-icon-error",
          desc: "Нет подключений агента",
        },
      },
    };
  },
};
</script>

<style lang="scss">
.status-switch {
  &,
  & * {
    cursor: default;
  }
}
.el-icon-error.agent-status {
  color: #000;
}
.el-icon-success.agent-status {
  color: #67c23a;
}
.el-icon-warning.agent-status {
  color: #fa5555;
}
</style>
